<template>
    <div class="list-notify">
        <LoginRequire pageId="PT110" />
        <router-link :to="{ name: 'signal' }" class="notify-setting"><i class="ri-settings-4-line"></i><span>{{$t('common.thiet_lap')}}</span></router-link>
        <div v-for="item in data" :key="'notify-' + item.Time" class="notify-item">
            <div class="notify-symbol">
                <router-link :to="{ name: 'enterprise', query: { secCode: item.securityCode } }">{{ item.securityCode }}</router-link>
            </div>
            <div class="notify-content">
                <span style="color: var(--color-secondary);">{{ item.time }}</span> - 
                <span>{{ getTitle(item.buySellInd, item.securityCode) }}</span> - 
                <span>{{ lang == 'vi' ? getDescription(item.realtimeFormulaId)?.Description : getDescription(item.realtimeFormulaId)?.Description_en}}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { TokenService } from '@/api/storageService';
import signalService from '@/api/signalService';
import LoginRequire from "@/components/LoginRequire.vue";

export default {
    props: ['data'],
    components: {
        LoginRequire
    },
    data() {    
        return {
            lang: 'vi',
            formula: [],
            lastSeen: ''
        }
    },
    created() {
        this.lang = TokenService.getLang() == '' ? 'vi' : TokenService.getLang();
        this.getFormula();
    },
    methods: {
        getTitle(buySellInd, securityCode) {
            if(buySellInd == 'B'){
                return this.lang == 'vi' ? securityCode + " vào vùng MUA" : securityCode + " is entering the buying zone"
            }
            else{
                return this.lang == 'vi' ? securityCode + " vào vùng BÁN" : securityCode + " is entering the selling zone"
            }
        },

        getDescription(formulaId) {
            const result = this.formula.filter((obj) => parseFloat(obj.id) == formulaId);
            return result[0];
        },

        getFormula() {
            signalService.getFormula().then((response) => {
                if (response.status == 200) {
                    this.formula = response.data;
                }
                else {
                    messageBox.showWarning('Có lỗi xảy ra');
                }
            }).finally();
        },
    }
}
</script>